// Shared between SignIn.js and VerifyOTP.js so both post-login flows redirect
// using the exact same role/permission logic.
export const getPostLoginRedirectUrl = (data) => {
  const roleDetails = data?.roleDetails || [];
  const permissions = data?.tabPermission || [];

  let redirectUrl = null;

  for (const menu of roleDetails) {
    if (!menu.isActive) continue;

    let tabUrl = "";

    // Parent has child
    if (menu.children && menu.children.length > 0) {
      const firstChild = menu.children.find(
        (child) => child.isActive && child.hasView,
      );

      if (firstChild) {
        tabUrl = firstChild.tabUrl;
      }
    } else {
      // Parent without child
      tabUrl = menu.tabUrl;
    }

    if (!tabUrl) continue;

    const hasPermission = permissions.some(
      (p) =>
        p.tabId?.tabUrl === tabUrl && p.view && p.isActive && p.tabId?.isActive,
    );

    if (hasPermission) {
      redirectUrl = tabUrl;
      break;
    }
  }

  return redirectUrl;
};

export default getPostLoginRedirectUrl;
